import './splash.css';
import Welcome from './welcome';
import { useNavigate } from 'react-router-dom';
import { useState, useEffect } from 'react';

const Splash = () => {
    const [show, setShow] = useState(true);
    const history = useNavigate();

    useEffect(() => {
        if (!show) {
            setTimeout(() => history('/home', { replace: true }), 900);
        }
      }, [show, history]);
    return (
        <div className="splash">
            { show &&
                <>
                    <div className="left-panel"></div>
                    <div className="right-panel"></div>
                </>
            }
            <Welcome hide={() => setShow(false)}/>
        </div>
    );
}

export default Splash;